import React, {useMemo} from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Box, Typography } from '@mui/material';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            callbacks: {
                label: (context) => `${context.raw}%`,
            },
        },
    },
    layout: {
        padding: {
            bottom: 40,
            top: 60,
        },
    },
    scales: {
        x: {
            type: "category",
            offset: true,
            title: {
                display: true,
                // text: 'Year',
                color: '#FFFFFF',
                font: {
                    size: window.innerWidth < 600 ? 14 : 22,
                    weight: 'bold',
                },
            },
            ticks: {
                color: '#FFFFFF',
                font: {
                    weight: 'bold',
                },
            },
            grid: {
                display: false,
            },
        },
        y: {
            beginAtZero: true,
            max: 90,
            stepSize: 6,
            title: {
                display: true,
                text: '% Child Cyber Risks',
                color: '#FFFFFF',
                font: {
                    size: window.innerWidth < 600 ? 14 : 22,
                    weight: 'bold',
                },
            },
            ticks: {
                color: '#FFFFFF',
                font: {
                    weight: 'bold',
                },
                callback: (value) => `${value}%`,
            },
            grid: {
                display: true,
                color: '#fff',
                borderDash: [6, 6],
                borderDashOffset: 3,
            },
        },
    },
};

const fillDataset = (data, targetLen) => {
    const filled = Array(targetLen).fill(null);
    data.forEach((val, i) => filled[i] = val);
    return filled;
};

const periodLabels = [
    "Pre-COVID\n(2017–2019)",
    "COVID-19 Pandemic\n(2020–2022)",
    "Post-COVID / Technology Transition\n(2023–2025)",
];

const CyberRiskMonitorComp = ({ cyberRiskMonitorData }) => {

    const filledData = useMemo(() => {
        if (!cyberRiskMonitorData || !Array.isArray(cyberRiskMonitorData.datasets) || !Array.isArray(cyberRiskMonitorData.labels)) {
            return { labels: [], datasets: [] };
        }

        // Format labels → split into text and year
        const formattedLabels = periodLabels.map(label => {
            const match = label.match(/^(.*)\s\((.*)\)$/);
            if (match) {
                return [match[1].trim(), match[2].trim()];
            }
            return label;
        });

        return {
            ...cyberRiskMonitorData,
            labels: formattedLabels,
            datasets: cyberRiskMonitorData.datasets.map(ds => ({
                ...ds,
                data: fillDataset(ds.data, cyberRiskMonitorData.labels.length)
            }))
        };
    }, [cyberRiskMonitorData]);

    return (
        <Box
            sx={{
                padding: {xs:'0 20px 0 0',sm: 3},
                mt: 3,
                ml: 'auto',
                mr: 'auto',
                mb:{xs:'-35px',sm:'0px'},
                borderRadius: 2,
                width: { xs: '100%', sm: '80%' },
                maxWidth: '1510px',
                height: { xs: '400px', sm: '635px' },
            }}
        >
            <Line data={filledData} options={options} />
        </Box>
    );
};

export default CyberRiskMonitorComp;